import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';
import { AgencyMasterProperties } from '../Models/AgencyMasterProperties';
import { SectorInformationProperties, BookingInfoProperties, RemoveSectorProperties, PassengerIds, AddUpdateSectorInfoProperties, BookingPassengerInfoProperties, OfflineTicketIssuancePassengerFares, OfflineTicketIssuancePassenger, RateOfExchangeRequestProp, RateOfExchangeResponse } from '../Models/BookingPassengerTicketIssuanceProperties';
import { Countries } from '../Models/Countries';
import { FlightSearchAirports } from '../Models/FlightSearchProperties';
import { TicketDataRequest, TicketIssuanceProperties } from '../Models/TicketIssuanceProperties';
import { UsersProperties } from '../Models/UsersProperties';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { PassengerInfoService } from '../Services/passengerInfo.service';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
import { document } from 'ngx-bootstrap/utils';
import { Router } from '@angular/router';
import { TicketSuppliersAccessCodeProperties, TicketSuppliersProperties } from '../Models/GroupTicketProperties';
import { GroupTicketService } from '../Services/groupTicket.service';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Select } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { DxDataGridModule } from 'devextreme-angular';
import { DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { Dialog } from 'primeng/dialog';
import { NgClass, DatePipe } from '@angular/common';
import { PrimeTemplate } from 'primeng/api';
@Component({
    selector: 'app-offline-ticket-issue',
    templateUrl: './offline-ticket-issue.component.html',
    styleUrls: ['./offline-ticket-issue.component.css'],
    imports: [NavMenuComponent, Bind, Select, FormsModule, DxDataGridModule, DxiColumnModule, DxTemplateModule, Dialog, NgClass, PrimeTemplate, DatePipe]
})
export class OfflineTicketIssueComponent {
  onlineBookingId: number;
  bookingAllData$: TicketIssuanceProperties;
  sectorInfo: SectorInformationProperties[] = [];
  bookingInfo = new BookingInfoProperties();
  bookingInfoForSupplierChange = new BookingInfoProperties();
  passengerInfo = new BookingPassengerInfoProperties();
  agencyOnline = new AgencyMasterProperties();
  userOnline = new UsersProperties();
  countryList: Countries[] | undefined;
  sectorAirports: FlightSearchAirports[] = [];
  bookingStatus: string;
  idCounter = -1;
  radioCheckedOneWay: boolean = false;
  radioCheckedRound: boolean = false;
  radioCheckedMultiCity: boolean = false;
  segmentDisabled: boolean[] = [];
  // loaderVar: boolean[] = [];
  loaderVar: boolean = false;
  loaderBool: boolean = false;
  currentDate: any;
  removeSector = new RemoveSectorProperties();
  paxId = new PassengerIds();
  addUpdateSector = new AddUpdateSectorInfoProperties();
  sectorInfoLenght: number = 0;
  passengerInfoLenght: number = 0;
  passengerInfoSubmitted = false;
  disabledFields: boolean = true;
  //passengerFare:PassengerFares[]=[];
  offlinePaxFare = new OfflineTicketIssuancePassengerFares();
  passengerBasics = new OfflineTicketIssuancePassenger();
  SaveTicketIssueButtonBool = false;
  ticketSupplierAccessCodeList: TicketSuppliersAccessCodeProperties[] | undefined;
  ticketSupplierAccessCode = new TicketSuppliersAccessCodeProperties();
  ticketSupplierList: TicketSuppliersProperties[] | undefined;
  primeShowModal: boolean = false;
  primeShowModalLoader: boolean = false;

  rateOfExchangeRequestProp = new RateOfExchangeRequestProp();
  rateOfExchangeResponse = new RateOfExchangeResponse();
  disabledExchangeRate: boolean = false;
  isSupplierUpdated: boolean = false;
  // passengerInfoList :BookingPassengerInfoProperties[]=[];

  @ViewChild('issueConfirmationModal') issueConfirmationModal: ElementRef;
  constructor(private ticketIssuanceService: TicketIssuanceService, private router: Router, private templateModel: NgbModal, private userService: PassengerInfoService,
    private flightService: FlightSearchService, private ticketService: GroupTicketService) {

  }
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "#f9f9f9", "color": "#212529", "font-weight": "bold" });
  };
  importId : number=0;
  ngOnInit() {
    this.getCountries();
    this.onlineBookingId = Number(localStorage.getItem("bookingID"));
    
    this.loadBookingInfoData(this.onlineBookingId);
    this.GetSectorsInfoBaseData();
    this.CurrentDate();



  }

  CurrentDate() {
    let date = new Date();
    let todayDate: any = date.getDate();
    let month: any = date.getMonth() + 1;
    let year = date.getFullYear();
    if (todayDate < 10) {
      todayDate = "0" + todayDate;
    }
    if (month < 10) {
      month = "0" + month;
    }
    this.currentDate = year + "-" + month + "-" + todayDate;

  }
  GetSectorsInfoBaseData() {
    this.flightService.GetFlightBaseData().subscribe((data) => {
      this.sectorAirports = data.airports;
    });
  }
  GetSearchBaseData = (supplierCode: string): void => {
    try {

      this.ticketService.GetTicketBaseData().subscribe((data) => {
        this.ticketSupplierList = data.ticketSuppliersProperties;
        this.GetSupplierAccessCodes(supplierCode);


      });

    }
    catch (e) {
      console.log(e)
    }
  }
  GetSupplierAccessCode = (supplierId: string): any => {
    this.ticketService.GetTicketAccessCode(supplierId).subscribe(data => {
      this.ticketSupplierAccessCodeList = data;
      this.passengerBasics.bookingPccCode = "";
    });

  }
  GetSupplierAccessCodes = (supplierId: string): any => {
    try {

      this.ticketService.GetTicketAccessCode(supplierId).subscribe(data => {
        this.ticketSupplierAccessCodeList = data;
        if (this.ticketSupplierAccessCodeList.length > 0) {
          this.ChangeBookingPCC(this.passengerBasics.bookingPccCode);

        }
      });
    }
    catch (ex) {
      console.log(ex);
    }
  }
  public ChangeBookingPCC = (pccCode: string): any => {
    if (this.passengerBasics.supplierCode == this.bookingInfo.bookingPassengerInfoProperties[0].supplierCode && pccCode == this.bookingInfo.bookingPassengerInfoProperties[0].bookingPccCode) {
      this.isSupplierUpdated = false;
      this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map((pax, index) => {
        return { ...pax, baseFare: this.bookingAllData$.bookingPassengerInfo[index].baseFare, totalTaxes: this.bookingAllData$.bookingPassengerInfo[index].totalTaxes }
      });
      // console.log(this.bookingAllData$.bookingPassengerInfo)
    }
    else {
      this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(pax => {
        return { ...pax, baseFare: 0, totalTaxes: 0 }
      });
      this.isSupplierUpdated = true;
    }
    const accessCode = this.ticketSupplierAccessCodeList.find(x => x.officeId === pccCode);
    if (accessCode) {
      this.ticketSupplierAccessCode = accessCode;
      if (this.ticketSupplierAccessCode.currencyName == localStorage.getItem("AgencyCurrency")) {
        this.disabledExchangeRate = true;
      }
      else {
        this.disabledExchangeRate = false;
      }
    }
    this.GetRateOfExchangeOffline();
  }
  private GetRateOfExchangeOffline = (): void => {
    let flightSearch = JSON.parse(this.bookingInfo.flightlocationInfoDBSave);
    this.rateOfExchangeRequestProp.flightProp = flightSearch.flightProp;
    this.rateOfExchangeRequestProp.sectorInformation = this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties;
    this.rateOfExchangeRequestProp.supplierCode = this.passengerBasics.supplierCode;
    this.rateOfExchangeRequestProp.supplierPccCode = this.passengerBasics.bookingPccCode;
    this.ticketIssuanceService.GetRateOfExchangeOffline(this.rateOfExchangeRequestProp).subscribe(data => {
      this.rateOfExchangeResponse = data;
      // console.log(this.rateOfExchangeResponse)
    })
  }
  public OnChangeExchangeRate = (): void => {
    //if (this.rateOfExchangeResponse.exchangeValue < 1) {
    //  this.rateOfExchangeResponse.exchangeValue = 1;
    //}
  }

  loadBookingInfoData(bookingID) {
    try {
      this.primeShowModalLoader = true;
      let ticketobj = new TicketDataRequest();
      this.bookingAllData$ = new TicketIssuanceProperties;
      ticketobj.agencyId = localStorage.getItem("AgencyId");
      ticketobj.userId = Number(localStorage.getItem("UserId"));
    //  ticketobj.bookingID = bookingID;
      //ticketobj.bookingID = 202498;
      //if (localStorage.getItem("ImportPnrRequestData") != undefined) {
      //  let requestObj = JSON.parse(localStorage.getItem("ImportPnrRequestData") || "");
      //  if (requestObj.requestTypeName == 'Online Import PNR Ticket Request') {

      //    this.ticketIssuanceService.GetPNRByID(bookingID, ticketobj.agencyId, ticketobj.userId).subscribe((data) => {
      //      this.importId = bookingID;
      //      ticketobj.bookingID = data.importPassengerPnrInfo[0].bookingID;
            
      //      localStorage.removeItem("bookingID");



      //      this.ticketIssuanceService.getBookingInfo(ticketobj).subscribe((data) => {
      //        this.bookingAllData$ = data;

      //        // console.log(this.bookingAllData$)
      //        this.bookingInfo = this.bookingAllData$.bookingInfo;
      //        this.bookingInfo.bookingPassengerInfoProperties = this.bookingAllData$.bookingPassengerInfo;
      //        //console.log(this.bookingInfo.bookingPassengerInfoProperties)
      //        this.primeShowModalLoader = false;
      //        if (this.bookingInfo.bookingPassengerInfoProperties.length > 0) {
      //          this.passengerBasics.exchangeCurrency = this.bookingInfo.bookingPassengerInfoProperties[0].exchangeCurrency;
      //          this.passengerBasics.baseCurrency = this.bookingInfo.bookingPassengerInfoProperties[0].baseCurrency;
      //          this.passengerBasics.pnr = this.bookingInfo.bookingPassengerInfoProperties[0].pnR_Doc;
      //          this.passengerBasics.supplierCode = this.bookingInfo.bookingPassengerInfoProperties[0].supplierCode;
      //          this.passengerBasics.bookingPccCode = this.bookingInfo.bookingPassengerInfoProperties[0].bookingPccCode;

      //          // this.ChangeBookingPCC(this.passengerBasics.bookingPccCode);

      //          if (this.passengerBasics.supplierCode != null && this.passengerBasics.supplierCode != undefined && this.passengerBasics.supplierCode != "") {
      //            this.GetSearchBaseData(this.passengerBasics.supplierCode);
      //          }
      //          for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {
      //            this.bookingInfo.bookingPassengerInfoProperties[i].passengerName = `${this.bookingInfo.bookingPassengerInfoProperties[i].firstName} ${this.bookingInfo.bookingPassengerInfoProperties[i].lastName}`;
      //          }
      //          this.radioCheckedOneWay = true;
               
      //          for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties.length; i++) {
      //            if (this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties.length > 0) {
      //              this.segmentDisabled[i] = true;
      //            }
      //            this.sectorInfo = this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties;
      //          }
      //        }

      //      });

      //    });
      //  }
      //}
        //else
        {
        ticketobj.bookingID = bookingID;


        localStorage.removeItem("bookingID");



        this.ticketIssuanceService.getBookingInfo(ticketobj).subscribe((data) => {
          this.bookingAllData$ = data;
          // console.log(this.bookingAllData$)
          this.bookingInfo = this.bookingAllData$.bookingInfo;
          this.bookingInfo.bookingPassengerInfoProperties = this.bookingAllData$.bookingPassengerInfo;
          //console.log(this.bookingInfo.bookingPassengerInfoProperties)
          this.primeShowModalLoader = false;
          if (this.bookingInfo.bookingPassengerInfoProperties.length > 0) {
            this.passengerBasics.exchangeCurrency = this.bookingInfo.bookingPassengerInfoProperties[0].exchangeCurrency;
            this.passengerBasics.baseCurrency = this.bookingInfo.bookingPassengerInfoProperties[0].baseCurrency;
            this.passengerBasics.pnr = this.bookingInfo.bookingPassengerInfoProperties[0].pnR_Doc;
            this.passengerBasics.supplierCode = this.bookingInfo.bookingPassengerInfoProperties[0].supplierCode;
            this.passengerBasics.bookingPccCode = this.bookingInfo.bookingPassengerInfoProperties[0].bookingPccCode;

            // this.ChangeBookingPCC(this.passengerBasics.bookingPccCode);

            if (this.passengerBasics.supplierCode != null && this.passengerBasics.supplierCode != undefined && this.passengerBasics.supplierCode != "") {
              this.GetSearchBaseData(this.passengerBasics.supplierCode);
            }
            for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {
              this.bookingInfo.bookingPassengerInfoProperties[i].passengerName = `${this.bookingInfo.bookingPassengerInfoProperties[i].firstName} ${this.bookingInfo.bookingPassengerInfoProperties[i].lastName}`;
              let newbaseFare = this.bookingInfo.bookingPassengerInfoProperties[i].baseFare + this.bookingInfo.bookingPassengerInfoProperties[i].additionalServiceCharges;
              this.bookingInfo.bookingPassengerInfoProperties[i].baseFare = newbaseFare;
            }
            if (localStorage.getItem("ImportPnrRequestData") != undefined) {
              this.radioCheckedOneWay = true;
              this.importId = bookingID;
            }
            else if (this.bookingInfo.bookingPassengerInfoProperties[0].sector.includes("(OW)")) {
              this.radioCheckedOneWay = true;
            }
            else if (this.bookingInfo.bookingPassengerInfoProperties[0].sector.includes("(RT)")) {
              this.radioCheckedRound = true;
            }
            else {
              this.radioCheckedMultiCity = true;
            }
            for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties.length; i++) {
              if (this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties.length > 0) {
                this.segmentDisabled[i] = true;
              }
              this.sectorInfo = this.bookingInfo.bookingPassengerInfoProperties[0].sectorInformationProperties;
            }
          }

        });
      }

    }
    catch (e) {
      console.log(e);
    }
  }
  getCountries() {
    try {
      this.userService.getCountries().subscribe((data) => {
        this.countryList = data;

      });
    }
    catch (e) {
      console.log(e);
    }
  }
  dateValidationDeparture(date, i) {
    if (date < this.currentDate) {
      this.sectorInfo[i].departureDate = this.currentDate;
    }
  }
  dateValidationArival(date, i) {
    if (date < this.currentDate) {
      this.sectorInfo[i].arrivalDate = this.currentDate;
    }
  }
  PassportDateValidation(date) {
    if (date < this.currentDate) {
      this.passengerInfo.passportValidTo = this.currentDate;
    }
  }
  DOBDateValidation(date) {
    if (date > this.currentDate) {
      this.passengerInfo.paxdob = this.currentDate;
    }
  }
  TicketBookingDateValidation(date) {
    if (date < this.currentDate) {
      this.passengerInfo.tktBookingDate = this.currentDate;
    }
  }
  parseDate(dateString: string) {
    if (dateString) {
      return dateString;
    }
    return null;
  }
  CapitalizedRBD(rbd, i) {
    this.sectorInfo[i].rbd = rbd.toUpperCase();
  }
  OpenModel(targetmodel) {
    this.templateModel.open(targetmodel, {

      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
    })
  }
  OneWaySectorClick(targetmodel) {
    this.radioCheckedOneWay = true;
    this.radioCheckedRound = false;
    this.radioCheckedMultiCity = false;

    this.OpenModel(targetmodel);
    if (this.sectorInfo.length == 0) {
      document.getElementById("sectorInfo_submit").style.display = 'none';
    }
    else {
      document.getElementById("sectorInfo_submit").style.display = 'block';
    }

  }
  RoundSectorClick(targetmodel) {
    this.radioCheckedOneWay = false;
    this.radioCheckedRound = true;
    this.radioCheckedMultiCity = false;
    this.OpenModel(targetmodel);
    if (this.sectorInfo.length == 0) {
      document.getElementById("sectorInfo_submit").style.display = 'none';
    }
    else {
      document.getElementById("sectorInfo_submit").style.display = 'block';
    }
  }
  MultiCitySectorClick(targetmodel) {
    this.radioCheckedOneWay = false;
    this.radioCheckedRound = false;
    this.radioCheckedMultiCity = true;
    this.OpenModel(targetmodel);
    if (this.sectorInfo.length == 0) {
      document.getElementById("sectorInfo_submit").style.display = 'none';
    }
    else {
      document.getElementById("sectorInfo_submit").style.display = 'block';
    }
  }
  AddSectorInformation() {
    document.getElementById("sectorInfo_submit").style.display = 'block';
    try {
      let obj = new SectorInformationProperties();
      if (this.radioCheckedOneWay == true) {
        for (let i = this.sectorInfo.length; i > 0; i--) {
          if (this.sectorInfo.length > 0) {
            obj.fromAirport = this.sectorInfo[i - 1].toAirport;

            this.segmentDisabled[i] = true;
            break;
          }
        }
      }
      this.sectorInfoLenght = 0;
      this.sectorInfoLenght = this.sectorInfo.length;
      if (this.sectorInfoLenght > 0) {
        if ((this.sectorInfo[this.sectorInfoLenght - 1].fromAirport != "" && this.sectorInfo[this.sectorInfoLenght - 1].fromAirport != undefined && this.sectorInfo[this.sectorInfoLenght - 1].fromAirport != null)
          && (this.sectorInfo[this.sectorInfoLenght - 1].toAirport != "" && this.sectorInfo[this.sectorInfoLenght - 1].toAirport != undefined && this.sectorInfo[this.sectorInfoLenght - 1].toAirport != null)
          && (this.sectorInfo[this.sectorInfoLenght - 1].flightNumber != "" && this.sectorInfo[this.sectorInfoLenght - 1].flightNumber != null && this.sectorInfo[this.sectorInfoLenght - 1].flightNumber != undefined)
          && (this.sectorInfo[this.sectorInfoLenght - 1].airlineCode != "" && this.sectorInfo[this.sectorInfoLenght - 1].airlineCode != null && this.sectorInfo[this.sectorInfoLenght - 1].airlineCode != undefined)
          && (this.sectorInfo[this.sectorInfoLenght - 1].departureDate != null && this.sectorInfo[this.sectorInfoLenght - 1].departureDate != undefined)
          && (this.sectorInfo[this.sectorInfoLenght - 1].arrivalDate != null && this.sectorInfo[this.sectorInfoLenght - 1].arrivalDate != undefined)
          && (this.sectorInfo[this.sectorInfoLenght - 1].baggageCabin != "" && this.sectorInfo[this.sectorInfoLenght - 1].baggageCabin != undefined && this.sectorInfo[this.sectorInfoLenght - 1].baggageCabin != null)
          && (this.sectorInfo[this.sectorInfoLenght - 1].baggageCheckIn != "" && this.sectorInfo[this.sectorInfoLenght - 1].baggageCheckIn != null && this.sectorInfo[this.sectorInfoLenght - 1].baggageCheckIn != undefined)
          && (this.sectorInfo[this.sectorInfoLenght - 1].cabinClass != "" && this.sectorInfo[this.sectorInfoLenght - 1].cabinClass != undefined && this.sectorInfo[this.sectorInfoLenght - 1].cabinClass != null)
          && (this.sectorInfo[this.sectorInfoLenght - 1].rbd != "" && this.sectorInfo[this.sectorInfoLenght - 1].rbd != null && this.sectorInfo[this.sectorInfoLenght - 1].rbd != undefined)) {
          this.sectorInfo.push(obj);
          for (let i = 1; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {
            this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties.push(obj);
          }

        }
        else {
          document.getElementById("sectorInfo_error").innerHTML = "**Please Fill Given Sector Information!"
          setTimeout(() => {
            document.getElementById("sectorInfo_error").innerHTML = ""
          }, 4000);
        }



      }
      else {
        this.sectorInfo.push(obj);
        for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {
          this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties.push(obj);
        }
      }


    } catch (e) {
      console.log(e);
    }
  }
  SectorSaveValidation() {
    let validations = false;
    let fromAirportValid = false, toAirportValid = false, flightNoValid = false,
      airlineCodeValid = false, departureDateValid = false, arrivalDateValid = false,
      baggageCabinValid = false, rbdValid = false, cabinClassValid = false;
    for (var i = 0; i < this.sectorInfo.length; i++) {
      if (this.sectorInfo[i].fromAirport != "" && this.sectorInfo[i].fromAirport != undefined && this.sectorInfo[i].fromAirport != null) {
        fromAirportValid = true;
        document.getElementById(`sectorInfoErrorFromAirport${i}`).innerHTML = "";
      }
      else {
        fromAirportValid = false;
        document.getElementById(`sectorInfoErrorFromAirport${i}`).innerHTML = "**From Airport Required!";
      }
      if (this.sectorInfo[i].toAirport != "" && this.sectorInfo[i].toAirport != undefined && this.sectorInfo[i].toAirport != null) {
        toAirportValid = true;
        document.getElementById(`sectorInfoErrorToAirport${i}`).innerHTML = "";
      }
      else {
        toAirportValid = false;
        document.getElementById(`sectorInfoErrorToAirport${i}`).innerHTML = "**To Airport Required!";
      }
      if (this.sectorInfo[i].flightNumber != "") {
        flightNoValid = true;
        document.getElementById(`sectorInfoErrorFlightNo${i}`).innerHTML = "";
      }
      else {
        flightNoValid = false;
        document.getElementById(`sectorInfoErrorFlightNo${i}`).innerHTML = "**Flight Number Required!";
      }
      if (this.sectorInfo[i].airlineCode != "") {
        airlineCodeValid = true;
        document.getElementById(`sectorInfoErrorairlineCode${i}`).innerHTML = "";
      }
      else {
        airlineCodeValid = false;
        document.getElementById(`sectorInfoErrorairlineCode${i}`).innerHTML = "**Airline Code Required!";
      }
      if (this.sectorInfo[i].departureDate != null) {
        departureDateValid = true;
        document.getElementById(`sectorInfoErrorDepartureDate${i}`).innerHTML = "";
      }
      else {
        departureDateValid = false;
        document.getElementById(`sectorInfoErrorDepartureDate${i}`).innerHTML = "**Departure Date Required!";
      }
      if (this.sectorInfo[i].arrivalDate != null) {
        arrivalDateValid = true;
        document.getElementById(`sectorInfoErrorArrivalDate${i}`).innerHTML = "";
      }
      else {
        arrivalDateValid = false;
        document.getElementById(`sectorInfoErrorArrivalDate${i}`).innerHTML = "**Arrival Date Required!";
      }
      if (this.sectorInfo[i].baggageCabin != "") {
        baggageCabinValid = true;
        document.getElementById(`sectorInfoErrorBaggageCabin${i}`).innerHTML = "";
      }
      else {
        baggageCabinValid = false;
        document.getElementById(`sectorInfoErrorBaggageCabin${i}`).innerHTML = "**Baggage Cabin Required!";
      }
      if (this.sectorInfo[i].cabinClass != "") {
        cabinClassValid = true;
        document.getElementById(`sectorInfoErrorCabinClass${i}`).innerHTML = "";
      }
      else {
        cabinClassValid = false;
        document.getElementById(`sectorInfoErrorCabinClass${i}`).innerHTML = "**Cabin Class Required!";
      }
      if (this.sectorInfo[i].rbd != "") {
        rbdValid = true;
        document.getElementById(`sectorInfoErrorRBD${i}`).innerHTML = "";
      }
      else {
        rbdValid = false;
        document.getElementById(`sectorInfoErrorRBD${i}`).innerHTML = "**RBD Required!";
      }





      if (toAirportValid && fromAirportValid && flightNoValid && airlineCodeValid && departureDateValid
        && arrivalDateValid && baggageCabinValid && cabinClassValid && rbdValid) {

        validations = true;
      }
      else {

        validations = false;
        break;
      }
    }
    return validations;
  }
  SaveSectorInformation() {
    if (this.SectorSaveValidation()) {
      if (this.radioCheckedOneWay == true) {

        this.templateModel.dismissAll();
      }
      else if (this.radioCheckedMultiCity == true) {

        this.templateModel.dismissAll();
      }
      else if (this.radioCheckedRound == true) {
        let sectorInfoLength: number = this.sectorInfo.length;
        if (this.sectorInfo[0].fromAirport != this.sectorInfo[sectorInfoLength - 1].toAirport) {
          document.getElementById("sectorInfo_error").innerHTML = "Origin of First Segment & Destination of last Segment Should be  Same!";
          document.getElementById(`originInfoLabel${0}`).style.color = 'red';
          document.getElementById(`destinationInfoLabel${sectorInfoLength - 1}`).style.color = 'red';
          setTimeout(() => {
            document.getElementById("sectorInfo_error").innerHTML = "";
            document.getElementById(`originInfoLabel${0}`).style.color = '';
            document.getElementById(`destinationInfoLabel${sectorInfoLength - 1}`).style.color = '';
          }, 5000)
        }
        else {

          this.templateModel.dismissAll();
        }

      }

    }

  }
  CancelSectorInformation() {
    this.sectorInfoLenght = 0;
    this.sectorInfoLenght = this.sectorInfo.length;
    if (this.sectorInfo[this.sectorInfoLenght - 1].id == 0) {
      this.sectorInfo.splice(this.sectorInfoLenght - 1, 1);
      this.templateModel.dismissAll();
    }
    else {
      this.templateModel.dismissAll();
    }
  }
  // RemoveSectorInformation(i) {
  //   try {
  //     this.loaderVar[i] = true;
  //     if (this.sectorInfo[i].id != 0) {
  //       document.getElementById(`sector_Remove_button${i}`).setAttribute('disabled', 'disabled');
  //       this.removeSector = new RemoveSectorProperties();
  //       this.removeSector.fromAirport = this.sectorInfo[i].fromAirport;
  //       this.removeSector.toAirport = this.sectorInfo[i].toAirport;
  //       this.removeSector.pnr_doc=this.bookingInfo.bookingPassengerInfoProperties[0].pnR_Doc
  //       // for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {
  //       //   if(this.bookingInfo.bookingPassengerInfoProperties[j].passengerID>0){
  //         // this.paxId = new PassengerIds();
  //         // this.paxId.passengerId = this.bookingInfo.bookingPassengerInfoProperties[j].passengerID
  //         // this.paxId.firstName = this.bookingInfo.bookingPassengerInfoProperties[j].firstName
  //         // this.paxId.pnrDoc = this.bookingInfo.bookingPassengerInfoProperties[j].pnR_Doc
  //         // this.removeSector.passengerId.push(this.paxId)
  //       //   }
  //       // }
  //      // console.log(this.removeSector.passengerId)
  //       this.ticketIssuanceService.RemoveSectorInformation(this.removeSector).subscribe(data => {
  //         if (data == true) {
  //           this.sectorInfo.splice(i, 1);
  //           this.loaderVar[i] = false;
  //           document.getElementById(`sector_Remove_button${i}`).removeAttribute('disabled');
  //         } else {
  //           this.loaderVar[i] = false;
  //           document.getElementById(`sector_Remove_button${i}`).removeAttribute('disabled');
  //         }

  //       })
  //     }
  //     else {
  //       if (this.sectorInfo[i].id == 0) {
  //         this.sectorInfo.splice(i, 1);

  //       }
  //       this.loaderVar[i] = false;
  //     }

  //   } catch (e) {
  //     console.log(e);
  //   }
  // }
  AddPassengerInformation(passengerInfoModal) {
    this.disabledFields = false;
    this.passengerInfo = new BookingPassengerInfoProperties();
    this.OpenModel(passengerInfoModal);
  }
  passengerInfoEdit = (data): void => {
    this.primeShowModal = true;
    this.disabledFields = true;
    
    this.passengerInfo = data;
   // this.passengerInfo.baseFare = this.passengerInfo.baseFare + this.passengerInfo.additionalServiceCharges;
    //this.OpenModel(passengerInfoModal);
  }
  PrimeCloseModal = (): void => {
    this.primeShowModal = false;
  }
  passengerInfoDelete(data, confirmationModal) {
    this.templateModel.open(confirmationModal, {

      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'md',
    })
    this.paxId = new PassengerIds();
    this.paxId.passengerId = data.passengerID;
    this.paxId.firstName = data.firstName;
    this.paxId.pnrDoc = data.pnR_Doc;
  }
  passengerInfoDeleteConfirmation() {
    if (this.paxId.passengerId < 0) {
      for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {
        if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerID == this.paxId.passengerId) {
          this.bookingInfo.bookingPassengerInfoProperties.splice(i, 1);
          break;
        }
      }
      this.templateModel.dismissAll();
    }
    else {
      this.loaderBool = true;
      document.getElementById("confirmationModelBtn_yes").setAttribute("disabled", "disabled");
      document.getElementById("confirmationModelBtn_cancel").setAttribute("disabled", "disabled");
      this.ticketIssuanceService.RemovePassengerInformation(this.paxId).subscribe((data) => {
        if (data == true) {
          this.loadBookingInfoData(this.bookingInfo.bookingID);
          this.loaderBool = false;
          document.getElementById("confirmationModelBtn_yes").removeAttribute("disabled");
          document.getElementById("confirmationModelBtn_cancel").removeAttribute("disabled");
          this.templateModel.dismissAll();
        }
        else {
          this.loaderBool = false;
          document.getElementById("confirmationModelBtn_yes").removeAttribute("disabled");
          document.getElementById("confirmationModelBtn_cancel").removeAttribute("disabled");
          document.getElementById("passengerInfoDeleteError").style.display = 'block';
          setTimeout(() => {
            document.getElementById("passengerInfoDeleteError").style.display = 'none';
          }, 4000);
        }

      })
    }

  }
  passengerInfoDeleteCancel() {
    this.loaderBool = false;
    this.templateModel.dismissAll();
  }
  SavePassengerInformation(passengerInfoForm) {
    this.passengerInfoSubmitted = true;
    if (!passengerInfoForm.valid) {
      return
    }
    else {
      this.passengerInfoSubmitted = false;
      if (this.passengerInfo.passengerID != 0) {
        this.PrimeCloseModal();
      }
      else {
        this.passengerInfo.passengerType = Number(this.passengerInfo.passengerType)
        this.passengerInfo.passengerID = this.idCounter;
        this.idCounter--;
        this.passengerInfo.passengerName = this.passengerInfo.firstName + ' ' + this.passengerInfo.lastName;
        this.bookingInfo.bookingPassengerInfoProperties.push(this.passengerInfo);
        this.PrimeCloseModal();
      }
    }
  }
  public OnChangeTaxAndFare = (): void => {
    if (this.passengerInfo.baseFare < 0) {
      this.passengerInfo.baseFare = 0;
    }
    if (this.passengerInfo.totalTaxes < 0) {
      this.passengerInfo.totalTaxes = 0;
    }
  }


  SaveTicketIssue() {
    if (this.bookingInfo.bookingPassengerInfoProperties.length > 0) {
     
      for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {
        if (this.passengerBasics.supplierCode == "" || this.passengerBasics.supplierCode == null || this.passengerBasics.supplierCode == undefined) {
          document.getElementById("supplierCodeInfoError").innerHTML = "**Supplier Code Required!";
          setTimeout(() => {
            document.getElementById("supplierCodeInfoError").innerHTML = "";
          }, 5000)
          return;
        }
        if (this.passengerBasics.bookingPccCode == "" || this.passengerBasics.bookingPccCode == null || this.passengerBasics.bookingPccCode == undefined) {
          document.getElementById("pccCodeInfoError").innerHTML = "**PCC Code Required!";
          setTimeout(() => {
            document.getElementById("pccCodeInfoError").innerHTML = "";
          }, 5000)
          return;
        }
        if ((this.bookingInfo.bookingPassengerInfoProperties[i].ticketNo == "") ||
          (this.bookingInfo.bookingPassengerInfoProperties[i].ticketNo == null) ||
          (this.bookingInfo.bookingPassengerInfoProperties[i].ticketNo == undefined)) {
          document.getElementById("SaveTicketIssueError").innerHTML = "**Please Enter Ticket Number of Passengers!";
          setTimeout(() => {
            document.getElementById("SaveTicketIssueError").innerHTML = "";
          }, 5000)
          return;
        }
        if ((this.bookingInfo.bookingPassengerInfoProperties[i].baseFare <=0) ||
          (this.bookingInfo.bookingPassengerInfoProperties[i].totalTaxes <= 0) ) {
          document.getElementById("SaveTicketIssueError").innerHTML = "**Invalid Fares!";
          setTimeout(() => {
            document.getElementById("SaveTicketIssueError").innerHTML = "";
          }, 5000)
          return;
        }
        else {
          this.bookingInfo.bookingPassengerInfoProperties[i].offlineIssuanceBaseFare = this.bookingInfo.bookingPassengerInfoProperties[i].baseFare;
          this.bookingInfo.bookingPassengerInfoProperties[i].offlineIssuanceTotalTaxes = this.bookingInfo.bookingPassengerInfoProperties[i].totalTaxes;
          this.bookingInfo.bookingPassengerInfoProperties[i].offlineIssuancePccCode = this.ticketSupplierAccessCode.officeId;
          this.bookingInfo.bookingPassengerInfoProperties[i].offlineIssuanceSupplier = this.ticketSupplierAccessCode.supplierId;
          this.bookingInfo.bookingPassengerInfoProperties[i].offlineIssuancePccIATA = this.ticketSupplierAccessCode.iataCode;
          this.bookingInfo.bookingPassengerInfoProperties[i].offlineIssuancePccCurrency = this.ticketSupplierAccessCode.currencyName;
          this.bookingInfo.bookingPassengerInfoProperties[i].offlineIssuanceExchangeRate = this.rateOfExchangeResponse.exchangeValue;
          this.bookingInfo.bookingPassengerInfoProperties[i].isOfflineIssuanceRequest = true;
        }
      }
      this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(pax => {
        return { ...pax, supplierCode: this.passengerBasics.supplierCode, issuancePccCode: this.passengerBasics.bookingPccCode, airlineCommisionValue: 0 }
      });
      this.loaderVar = true;
      this.SaveTicketIssueButtonBool = true;
      this.bookingInfo.bookingStatus = 2;
      this.bookingInfo.issuanceUser = Number(localStorage.getItem("UserId"));
      this.bookingInfo.userBackSystemCompanyId = Number(localStorage.getItem("BackSystemCompanyId"));
      this.bookingInfo.userBackSystemCustomer = localStorage.getItem("BackSystemCompanyCustomer");
      this.bookingInfo.currencyRateByDefault = this.rateOfExchangeResponse.exchangeValue;
      this.bookingInfo.currencyCriteriaThatApplied = this.rateOfExchangeResponse.appliedCriteria;
      this.bookingInfo.revenueApplied = "";
      if (this.isSupplierUpdated == true) {
        this.bookingInfoForSupplierChange = this.bookingInfo;
        this.ticketIssuanceService.CheckRevenueOnSupplierChange(this.bookingInfoForSupplierChange).subscribe(booking => {
          if (booking != null) {
            for (let pf = 0; pf < booking.passengerFares.length; pf++) {
              const agencyWiseFare = booking.passengerFares[pf].agencyWiseFare.find(a => a.agency_BranchId === 'AG01');
              if (agencyWiseFare) {
                this.bookingInfo.bookingPassengerInfoProperties = this.bookingInfo.bookingPassengerInfoProperties.map(pax => {
                  if (pax.passengerType && Number(booking.passengerFares[pf].passengerType)) {
                    return { ...pax, offlineIssuanceCommissionOff: agencyWiseFare.airlineCommisionValue + agencyWiseFare.airlineCommision }
                  }
                  return pax;

                });
              }

            }
            if (this.importId > 0) {
              this.ticketIssuanceService.ConfirmOfflineTicketIssuance(this.bookingInfo).subscribe(data => {
                if (data.isSaved == true) {
                  this.loaderVar = false;
                  this.SaveTicketIssueButtonBool = false;
                  
                    localStorage.setItem('importPNRID', this.importId.toString());
                    localStorage.setItem("fromroutePageNoright", "ImportPNRPage");
                    this.router.navigateByUrl('/importPNR');
                  
                  


                }
                else {
                  this.loaderVar = false;
                  this.SaveTicketIssueButtonBool = false;
                  document.getElementById("SaveTicketIssueError").innerHTML = data.errorInfo;
                  setTimeout(() => {
                    document.getElementById("SaveTicketIssueError").innerHTML = "";
                  }, 5000)
                }
              })
            }
            else {
              this.ticketIssuanceService.ConfirmOfflineTicketIssuance(this.bookingInfo).subscribe(data => {
                if (data.isSaved == true) {
                  this.loaderVar = false;
                  this.SaveTicketIssueButtonBool = false;
                  if (this.importId == 0 || this.importId == undefined || this.importId == null) {
                    localStorage.setItem("bookingID", this.bookingInfo.bookingID.toString());
                    this.router.navigate(['/ticket-issuance']);
                  }
                  else {

                  }


                }
                else {
                  this.loaderVar = false;
                  this.SaveTicketIssueButtonBool = false;
                  document.getElementById("SaveTicketIssueError").innerHTML = data.errorInfo;
                  setTimeout(() => {
                    document.getElementById("SaveTicketIssueError").innerHTML = "";
                  }, 5000)
                }
              })
            }
          }
        });
      }
      else {
        if (this.importId > 0) {
          this.ticketIssuanceService.ConfirmOfflineImportTicketIssuance(this.bookingInfo).subscribe(data => {
            if (data.isSaved == true) {
              this.loaderVar = false;
              this.SaveTicketIssueButtonBool = false;

              localStorage.setItem('importPNRID', this.importId.toString());
              localStorage.setItem("fromroutePageNoright", "ImportPNRPage");
              this.router.navigateByUrl('/importPNR');




            }
            else {
              this.loaderVar = false;
              this.SaveTicketIssueButtonBool = false;
              document.getElementById("SaveTicketIssueError").innerHTML = data.errorInfo;
              setTimeout(() => {
                document.getElementById("SaveTicketIssueError").innerHTML = "";
              }, 5000)
            }
          })
        }
        else {
          this.ticketIssuanceService.ConfirmOfflineTicketIssuance(this.bookingInfo).subscribe(data => {
            if (data.isSaved == true) {
              this.loaderVar = false;
              this.SaveTicketIssueButtonBool = false;
              localStorage.setItem("bookingID", this.bookingInfo.bookingID.toString());
              this.router.navigate(['/ticket-issuance']);

            }
            else {
              this.loaderVar = false;
              this.SaveTicketIssueButtonBool = false;
              document.getElementById("SaveTicketIssueError").innerHTML = data.errorInfo;
              setTimeout(() => {
                document.getElementById("SaveTicketIssueError").innerHTML = "";
              }, 5000)
            }
          })
        }
      }


    }








    // this.sectorInfoLenght = this.sectorInfo.length;
    // for (let i = 0; i < this.bookingInfo.bookingPassengerInfoProperties.length; i++) {
    //   if (this.radioCheckedOneWay == true) {

    //     this.bookingInfo.bookingPassengerInfoProperties[i].sector = `${this.sectorInfo[0].fromAirport} to${this.sectorInfo[this.sectorInfoLenght - 1].toAirport} (OW)`;
    //     this.bookingInfo.bookingPassengerInfoProperties[i].tripType = "OneWay";
    //   }
    //   else if (this.radioCheckedRound == true) {
    //     if ((this.bookingAllData$.sectorInfo.length != this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties.length)
    //       && (this.bookingAllData$.sectorInfo[0].fromAirport != this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[0].fromAirport)
    //       && (this.bookingAllData$.sectorInfo[this.bookingAllData$.sectorInfo.length - 1].toAirport != this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties.length - 1].toAirport)) {
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sector = `${this.sectorInfo[0].fromAirport} to${this.sectorInfo[this.sectorInfoLenght - 1].toAirport} (RT)Offline`;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].tripType = "Round";

    //     }
    //     else {
    //       this.bookingInfo.bookingPassengerInfoProperties[i].tripType = "Round";
    //     }
    //   }
    //   else if (this.radioCheckedMultiCity == true) {
    //     if ((this.bookingAllData$.sectorInfo.length != this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties.length)
    //       && (this.bookingAllData$.sectorInfo[0].fromAirport != this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[0].fromAirport)
    //       && (this.bookingAllData$.sectorInfo[this.bookingAllData$.sectorInfo.length - 1].toAirport != this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties.length - 1].toAirport)) {
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sector = `${this.sectorInfo[0].fromAirport} to${this.sectorInfo[this.sectorInfoLenght - 1].toAirport} (Multi)Offline`;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].tripType = "Multicity";
    //     }
    //     else {
    //       this.bookingInfo.bookingPassengerInfoProperties[i].tripType = "Multicity";
    //     }

    //   }
    //   this.bookingInfo.bookingPassengerInfoProperties[i].exchangeCurrency = this.passengerBasics.exchangeCurrency;
    //   this.bookingInfo.bookingPassengerInfoProperties[i].netToSupplier = this.bookingInfo.bookingPassengerInfoProperties[i].totalTaxes + this.bookingInfo.bookingPassengerInfoProperties[i].baseFare;
    //   this.bookingInfo.bookingPassengerInfoProperties[i].passengerType = Number(this.bookingInfo.bookingPassengerInfoProperties[i].passengerType);
    //   this.bookingInfo.bookingPassengerInfoProperties[i].supplierCode = this.passengerBasics.supplierCode;
    //   this.bookingInfo.bookingPassengerInfoProperties[i].bookingPccCode = this.passengerBasics.bookingPccCode;
    //   this.bookingInfo.bookingPassengerInfoProperties[i].baseCurrency = this.passengerBasics.baseCurrency;
    //   this.bookingInfo.bookingPassengerInfoProperties[i].serviceCharges = 0;
    //   this.bookingInfo.bookingPassengerInfoProperties[i].discount = 0;
    //   this.bookingInfo.bookingPassengerInfoProperties[i].markup = 0;


    //   for (let j = 0; j < this.sectorInfo.length; j++) {

    //     if (this.bookingInfo.bookingPassengerInfoProperties[i].passengerID < 0) {
    //       let sector = new SectorInformationProperties();
    //       sector.fromAirport = this.sectorInfo[j].fromAirport;
    //       sector.fromAirportName = this.sectorInfo[j].fromAirport;
    //       sector.toAirport = this.sectorInfo[j].toAirport;
    //       sector.toAirportName = this.sectorInfo[j].toAirport;
    //       sector.flightNumber = this.sectorInfo[j].flightNumber;
    //       sector.airlineCode = this.sectorInfo[j].airlineCode;
    //       sector.departureDate = this.sectorInfo[j].departureDate;
    //       sector.arrivalDate = this.sectorInfo[j].arrivalDate;
    //       sector.baggageCabin = this.sectorInfo[j].baggageCabin;
    //       sector.baggageCheckIn = this.sectorInfo[j].baggageCheckIn;
    //       sector.cabinClass = this.sectorInfo[j].cabinClass;
    //       sector.rbd = this.sectorInfo[j].rbd;
    //       this.sectorInfo[j].passengerID = this.bookingInfo.bookingPassengerInfoProperties[i].passengerID
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties.push(sector)

    //     }
    //     else {

    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].fromAirport = this.sectorInfo[j].fromAirport;

    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].fromAirportName = this.sectorInfo[j].fromAirport;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].toAirport = this.sectorInfo[j].toAirport;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].toAirportName = this.sectorInfo[j].toAirport;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].flightNumber = this.sectorInfo[j].flightNumber;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].airlineCode = this.sectorInfo[j].airlineCode;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].departureDate = this.sectorInfo[j].departureDate;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].arrivalDate = this.sectorInfo[j].arrivalDate;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].baggageCabin = this.sectorInfo[j].baggageCabin;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].baggageCheckIn = this.sectorInfo[j].baggageCheckIn;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].cabinClass = this.sectorInfo[j].cabinClass;
    //       this.bookingInfo.bookingPassengerInfoProperties[i].sectorInformationProperties[j].rbd = this.sectorInfo[j].rbd;
    //     }

    //   }

    // }
    //console.log(this.bookingInfo.bookingPassengerInfoProperties)


    // this.ticketIssuanceService.offlineTicketIssuance(this.bookingInfo).subscribe(data => {

    //   if (data !=null) {
    //     this.bookingInfo = data
    //     // console.log(this.bookingInfo)
    //     //  console.log(this.passengerFare);
    //     for (let i = 0; i < this.bookingInfo.passengerFares.length; i++) {
    //       if (Number(this.bookingInfo.passengerFares[i].passengerType) == 1) {
    //         if (this.bookingInfo.passengerFares[i].count > 0) {
    //           this.offlinePaxFare.serviceFeeAdult = Number(this.bookingInfo.passengerFares[i].serviceFee.slice(3)) / this.bookingInfo.passengerFares[i].count;
    //           this.offlinePaxFare.markupAdult = Number(this.bookingInfo.passengerFares[i].markup.slice(3)) / this.bookingInfo.passengerFares[i].count;
    //           this.offlinePaxFare.discountAdult = Number(this.bookingInfo.passengerFares[i].discount.slice(3)) / this.bookingInfo.passengerFares[i].count;
    //           //  this.offlinePaxFare.serviceFeeAdult= Number(this.bookingInfo.passengerFares[i].serviceFee.slice(3));
    //           //  this.offlinePaxFare.markupAdult= Number(this.bookingInfo.passengerFares[i].markup.slice(3));
    //           //  this.offlinePaxFare.discountAdult= Number(this.bookingInfo.passengerFares[i].discount.slice(3));
    //         }
    //       }
    //       else if (Number(this.bookingInfo.passengerFares[i].passengerType) == 2) {
    //         if (this.bookingInfo.passengerFares[i].count > 0) {
    //           this.offlinePaxFare.serviceFeeChild = Number(this.bookingInfo.passengerFares[i].serviceFee.slice(3)) / this.bookingInfo.passengerFares[i].count;
    //           this.offlinePaxFare.markupChild = Number(this.bookingInfo.passengerFares[i].markup.slice(3)) / this.bookingInfo.passengerFares[i].count;
    //           this.offlinePaxFare.discountChild = Number(this.bookingInfo.passengerFares[i].discount.slice(3)) / this.bookingInfo.passengerFares[i].count;
    //           //  this.offlinePaxFare.serviceFeeChild= Number(this.bookingInfo.passengerFares[i].serviceFee.slice(3));
    //           //  this.offlinePaxFare.markupChild= Number(this.bookingInfo.passengerFares[i].markup.slice(3));
    //           //  this.offlinePaxFare.discountChild= Number(this.bookingInfo.passengerFares[i].discount.slice(3));
    //         }
    //       }
    //       else if (Number(this.bookingInfo.passengerFares[i].passengerType) == 3) {
    //         if (this.bookingInfo.passengerFares[i].count > 0) {
    //           //  this.offlinePaxFare.serviceFeeInfant= Number(this.bookingInfo.passengerFares[i].serviceFee.slice(3));
    //           //  this.offlinePaxFare.markupInfant= Number(this.bookingInfo.passengerFares[i].markup.slice(3));
    //           //  this.offlinePaxFare.discountInfant= Number(this.bookingInfo.passengerFares[i].discount.slice(3));
    //           this.offlinePaxFare.serviceFeeInfant = Number(this.bookingInfo.passengerFares[i].serviceFee.slice(3)) / this.bookingInfo.passengerFares[i].count;
    //           this.offlinePaxFare.markupInfant = Number(this.bookingInfo.passengerFares[i].markup.slice(3)) / this.bookingInfo.passengerFares[i].count;
    //           this.offlinePaxFare.discountInfant = Number(this.bookingInfo.passengerFares[i].discount.slice(3)) / this.bookingInfo.passengerFares[i].count;
    //         }
    //       }
    //     }
    //     for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {


    //       if (this.bookingInfo.bookingPassengerInfoProperties[j].passengerType == 1) {
    //         this.bookingInfo.bookingPassengerInfoProperties[j].serviceCharges = this.offlinePaxFare.serviceFeeAdult;
    //         this.bookingInfo.bookingPassengerInfoProperties[j].discount = this.offlinePaxFare.discountAdult;
    //         this.bookingInfo.bookingPassengerInfoProperties[j].markup = this.offlinePaxFare.markupAdult;
    //       }
    //       else if (this.bookingInfo.bookingPassengerInfoProperties[j].passengerType == 2) {
    //         this.bookingInfo.bookingPassengerInfoProperties[j].serviceCharges = this.offlinePaxFare.serviceFeeChild;
    //         this.bookingInfo.bookingPassengerInfoProperties[j].discount = this.offlinePaxFare.discountChild;
    //         this.bookingInfo.bookingPassengerInfoProperties[j].markup = this.offlinePaxFare.markupChild;
    //       }
    //       else if (this.bookingInfo.bookingPassengerInfoProperties[j].passengerType == 3) {
    //         this.bookingInfo.bookingPassengerInfoProperties[j].serviceCharges = this.offlinePaxFare.serviceFeeInfant;
    //         this.bookingInfo.bookingPassengerInfoProperties[j].discount = this.offlinePaxFare.discountInfant;
    //         this.bookingInfo.bookingPassengerInfoProperties[j].markup = this.offlinePaxFare.markupInfant;
    //       }

    //     }
    //     // console.log(this.passengerFare)
    //    // this.bookingInfo.passengerFares = this.passengerFare;
    //     this.OpenModel(this.issueConfirmationModal);
    //     // console.log(this.bookingInfo);
    //   }
    //   else {
    //     document.getElementById("SaveTicketIssueError").innerHTML = "**Something Went Wrong!";
    //     setTimeout(() => {
    //       document.getElementById("SaveTicketIssueError").innerHTML = "";
    //     }, 3000)
    //   }
    // });


  }

  // ConfirmTicketIssuanceModelCancel(){
  //   this.loadBookingInfoData(this.onlineBookingId);
  //   this.templateModel.dismissAll();
  // }
  // ConfirmTicketIssuance(){
  //   // this.bookingInfo.bookingStatus=2;
  //   // this.bookingInfo.issuanceUser=Number(localStorage.getItem("UserId"));
  //   // this.bookingInfo.userBackSystemCompanyId=Number(localStorage.getItem("BackSystemCompanyId"));
  //   // this.bookingInfo.userBackSystemCustomer=localStorage.getItem("BackSystemCompanyCustomer");
  //   // document.getElementById("confirmTicketIssuanceBtn_Confirm").style.display='none';
  //   // document.getElementById("confirmTicketIssuanceBtn_cancel").style.display='none';

  //   // for (let j = 0; j < this.bookingInfo.bookingPassengerInfoProperties.length; j++) {
  //   //   this.bookingInfo.bookingPassengerInfoProperties[j].serviceCharges=0;
  //   //   this.bookingInfo.bookingPassengerInfoProperties[j].discount=0;
  //   //   this.bookingInfo.bookingPassengerInfoProperties[j].markup= 0;  
  //   //   this.bookingInfo.bookingPassengerInfoProperties[j].netFromCustomer= 0;  
  //   //   this.bookingInfo.bookingPassengerInfoProperties[j].airlineCode= this.bookingInfo.bookingPassengerInfoProperties[0].airlineCode;  
  //   //   this.bookingInfo.bookingPassengerInfoProperties[j].travelingDate= this.bookingInfo.bookingPassengerInfoProperties[0].travelingDate
  //   //  }
  //   // this.ticketIssuanceService.ConfirmOfflineTicketIssuance(this.bookingInfo).subscribe(data=>{
  //   //  // console.log(data);
  //   //   if(data.isSaved==true){
  //   //     this.loadBookingInfoData(this.onlineBookingId);
  //   //     this.SaveTicketIssueButtonBool = true;
  //   //     document.getElementById("confirmTicketIssuanceBtn_Confirm").style.display='block';
  //   //     document.getElementById("confirmTicketIssuanceBtn_cancel").style.display='block';
  //   //     this.templateModel.dismissAll();
  //   //   }
  //   //   else{
  //   //     document.getElementById("confirmTicketIssuance_error").innerHTML = data.errorInfo;
  //   //     document.getElementById("confirmTicketIssuanceBtn_Confirm").style.display='block';
  //   //     document.getElementById("confirmTicketIssuanceBtn_cancel").style.display='block';
  //   //     setTimeout(()=>{
  //   //       document.getElementById("confirmTicketIssuance_error").innerHTML="";
  //   //     },5000)
  //   //   }
  //   // })
  // }





}
